/**
 * Centurion Matting - Media URL config.
 *
 * 4 hero images plus shared crops for the Field Conditions strip.
 * Phase 1 corrections: added truckLoaded (new home hero), millYard
 * (about + section break), logoMark (header brand mark).
 */

export const HERO_MEDIA = {
    // Reverted cinematic forest truck - original truckLoaded photo
    // (no AI-generated stamps; sort_order=0 lead slide).
    realTruckHero: {
        src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/aa7fcee2b5400d9d9da8c94f58c5764aa11fffd1abd5093644a8ed0e05da145f.jpeg',
        alt: 'Centurion mat truck loaded with timber access mats heading into a forest corridor - Manufacturer Direct from BC',
        caption: 'Manufacturer Direct - straight from the mill floor',
    },

    // Authentic Centurion-stamped truck photo - real product, real
    // stamps. sort_order=1 slide.
    authenticTruck: {
        src: 'https://customer-assets.emergentagent.com/job_digital-matting/artifacts/5o08i8jk_Cent%20Truck.JPEG',
        alt: 'Authentic Centurion-stamped timber access mats loaded on a heavy-duty truck',
        caption: 'Authentic Centurion stamp - Chemainus mill yard',
    },

    // NEW Home - loaded mat truck on the road (primary brand-authentic hero)
    truckLoaded: {
        src: 'https://customer-assets.emergentagent.com/job_digital-matting/artifacts/5o08i8jk_Cent%20Truck.JPEG',
        alt: 'Blue Centurion truck loaded with timber access mats at the Chemainus mill - Manufacturer Direct',
        caption: 'Manufacturer Direct delivery',
    },

    // Mill yard - used on /about and as section break
    millYard: {
        src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/36a73035a6e81a9163ebb5465d4a9e00af80f31fe2c452ccd4da60afb7fa2094.jpeg',
        alt: 'Centurion mill yard - stacked timber matting product, Chemainus BC',
        caption: 'Mill yard - BC manufacturing',
    },

    // Authentic client photo - drone aerial of a BC mountain pipeline
    // access road, mat-built right-of-way through forest corridor.
    // (Was: muskeg-themed AI render; updated to real construction photo.)
    muskeg: {
        src: 'https://customer-assets.emergentagent.com/job_digital-matting/artifacts/wvmvbemg_Access%20road%20for%20pipeline%20construction%20beside%20highway.jpeg',
        alt: 'Aerial of a Centurion mat-built pipeline access road through a BC mountain corridor',
        caption: 'Pipeline access - Western Canada right-of-way',
    },

    // Access Mats hub - heavy snow field, mats laid through deep snow
    snowField: {
        src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/9166e4fe5ea6e4f670b1fc7452b213a227afa7d63f13dbc13600a4fb0a1d45a1.jpeg',
        alt: 'Timber access mats laid across a deep snow field',
        caption: 'Winter access - northern BC',
    },

    // Crane Mats hub - engineered crane pad with rigging in frame
    cranePad: {
        src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/bd0c7c0c52fdd854865ec6885aa63b059e9ba2d98181ad5ba95b2eb7001c86fa.jpeg',
        alt: 'Engineered crane pad built from Centurion crane mats',
        caption: 'Crane pad - load-rated assembly',
    },

    // Rig Mats / Indigenous / About - aerial view of access corridor through forest
    aerialCorridor: {
        src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/561281f57640a44488b86208e11be8df56574b173f2d3386f197f37bf58509a7.jpeg',
        alt: 'Aerial view of a Centurion mat access corridor through forest',
        caption: 'Aerial corridor - pipeline ROW',
    },

    // Phase 6 imagery - Project & Partnership leaf pages
    pipelineConstruction: {
        src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/3746b5d420e33f3c0585c621f80ed51ce3622ca75d2d487723184f6a09944f20.jpeg',
        alt: 'Pipeline construction corridor protected by Centurion timber access mats',
        caption: 'Pipeline corridor - Western Canada',
    },
    windFarmConstruction: {
        src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/787fb4509fda7143f6beef2b3d37a687abc6beb2373c58c336c20c03fafe9774.jpeg',
        alt: 'Wind turbine assembly on a Centurion crane mat pad',
        caption: 'Wind farm crane lift',
    },
    sustainableForestry: {
        src: '/api/uploads/hero/451de8b47b764858be2a370bbde1f4bf.png',
        alt: 'Centurion-stamped mat stacks staged in a coastal Hem-Fir forest at sunrise',
        caption: 'Centurion mats at the source - coastal Hem-Fir forest, BC',
    },
    logisticsDepot: {
        src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/ab7a152186385d2a58822e170af620955a9a56e733b8a0d0c53967de31f06f4b.jpeg',
        alt: 'Centurion mat logistics depot - Manufacturer Direct dispatch',
        caption: 'Mill yard dispatch - Chemainus, BC',
    },
};

// Transparent-background product silhouettes - uploaded by the customer
// through the admin UI; served from persistent backend storage.
// Routed to each product page by the original filename's prefix.
export const PRODUCT_MEDIA = {
    accessMat: {
        src: '/api/uploads/hero/35d45bdd8c054a0a999838ff1c76fc2c.png',
        alt: 'Centurion 3-ply interlocking access mat - 8\u2032 \u00d7 14\u2032 deck',
    },
    rigMat: {
        src: '/api/uploads/hero/871f9fce3edc40c2b284839ace25d9d7.png',
        alt: 'Centurion heavy-timber rig mat - engineered for crane and drilling pads',
    },
    craneMat: {
        src: '/api/uploads/hero/7040806a26674288800dcf4553e39191.png',
        alt: 'Centurion 4 \u00d7 20 crane mat',
    },
};

export const LOGO_MARK = {
    src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/99ea3af83c202f7199df2691bcd03153f6062e6c54ad84c530cea7e53bc6268b.jpeg',
    alt: 'Centurion Matting Products mark',
};

// OFFICIAL company logo - Centurion blue wordmark + gold chevron T-mark
// + gold "MATTING PRODUCTS" subtitle on white. The brand-true canonical
// asset; rendered against matte-black surfaces inside a small white
// "license plate" pill (see Brand.jsx).
export const OFFICIAL_LOGO = {
    src: 'https://customer-assets.emergentagent.com/job_digital-matting/artifacts/xeaopwlk_centurion-logo-1.png',
    alt: 'Centurion Matting Products',
};

// Reference only - not rendered anywhere. Kept commented for traceability.
// export const LOGO_DARK_BG = {
//     src: 'https://static.prod-images.emergentagent.com/jobs/73a4482e-3a89-436b-87a5-2e4ecc0997f1/images/696d1b5ce2334b587738fcae74723104de077ff144905afc6965f23fde4ecc5c.jpeg',
//     alt: 'Centurion Matting Products - dark-bg variant',
// };

// Field Conditions strip on the home page - 3 captioned images.
export const FIELD_CONDITIONS = [
    { ...HERO_MEDIA.muskeg, label: 'Mountain Corridor' },
    { ...HERO_MEDIA.snowField, label: 'Snow' },
    { ...HERO_MEDIA.aerialCorridor, label: 'Pipeline Corridor' },
];

// Authoritative offices - per centurionmatting.com/contactus.
// Chemainus, BC is the milling/manufacturing location; Calgary, AB is the
// corporate / sales office (Tyler Hachey's 403 number is Calgary's area code).
export const OFFICES = [
    {
        key: 'bc',
        region: 'British Columbia',
        label: 'Chemainus, BC',
        lines: ['3070 Henry Rd', 'Chemainus, BC V0R 1K5'],
        streetAddress: '3070 Henry Rd',
        addressLocality: 'Chemainus',
        addressRegion: 'BC',
        postalCode: 'V0R 1K5',
        addressCountry: 'CA',
    },
    {
        key: 'ab',
        region: 'Alberta',
        label: 'Calgary, AB',
        lines: ['2100, 112 - 4th Ave SW', 'Calgary, AB T2P 0H3'],
        streetAddress: '2100, 112 - 4th Ave SW',
        addressLocality: 'Calgary',
        addressRegion: 'AB',
        postalCode: 'T2P 0H3',
        addressCountry: 'CA',
    },
];

// Sales team - per centurionmatting.com/contactus. LinkedIn URLs are
// placeholders until the customer supplies them; flagged with
// data-needs-url for easy find-later.
export const SALES_TEAM = [
    {
        key: 'tyler',
        name: 'Tyler Hachey',
        role: 'Director of Sales, North America',
        phone: '+14037772600',
        phoneDisplay: '403-777-2600',
        email: null,
        linkedin: 'https://www.linkedin.com/in/tylerhachey/',
    },
    {
        key: 'jordan',
        name: 'Jordan Hickmott',
        role: 'Sales Coordinator',
        phone: null,
        email: 'sales@centurionmatting.com',
        needsPersonalEmail: 'jordan',
        linkedin: 'https://www.linkedin.com/in/jordan-hickmott-b29bb0150/',
    },
];

export const SITE = {
    name: 'Centurion Matting Products',
    wordmark: 'CENTURION',
    wordmarkSub: 'Matting Products',
    tagline: 'Manufacturer Direct since 1955',
    locations: 'Chemainus, BC + Calgary, AB',
    sister: 'Bear Valley Solutions',
    sisterUrl: 'https://bearvalleysolutions.com/centurion-matting',
    parentOrg: 'Centurion Lumber Ltd.',
    url: 'https://centurionmatting.com',
    phone: '+14037772600',
    phoneDisplay: '403-777-2600',
    description:
        "Centurion Matting Products - Manufacturer Direct timber access, rig and crane mats since 1955. Family-owned, milled in Chemainus, BC with sales offices in Calgary, AB.",
    serving: 'Serving Western Canada - BC, AB, SK, MB, YT, NT and beyond',
    salesEmail: 'sales@centurionmatting.com',
};
